export default __webpack_public_path__ + "static/media/FAC2.341f1d9b.jpg";